module.exports = __webpack_public_path__ + "img/whatisapcn.c32365b4.svg";